import React from "react";
import "./Projects.css"; // Import the external CSS file

const projects = [
  {
    title: "RAG based Chatbot",
    description:
      "Designed an AI chatbot using Retrieval-Augmentation Generation, based on the book Hands-on Machine Learning with Scikit-Learn, Keras, and TensorFlow (O'Reilly). Integrated LangChain for more sophisticated language model capabilities and leveraged Streamlit for an intuitive UI, enabling the chatbot to answer questions and provide insights from the book more effectively.",
    imageUrl: require("../images/chatbot book.png"),
  },
  {
    title: "Image Classification between Lethal and non-Lethal items",
    description:
      "Researched on a project that classifies whether items in images are lethal or non-lethal using Python with NumPy. The program developed a deep neural network without relying on functionalities from other libraries",
    imageUrl: require("../images/lethal and non lethal.png"),
  },
  {
    title: "Dog Breed Classification",
    description:
      "Carried out a project on the classification of dog breed images using Dog Vision. Utilized TensorFlow for building and training neural networks, while Pandas and NumPy were used for data preprocessing and management. The project demonstrates experience in image classification, convolutional neural networks, and working with structured datasets for machine learning tasks",
    imageUrl: require("../images/dog breed.png"),
  },
  {
    title: "California Housing Prediction",
    description:
      "Designed a project in Python using Scikit-learn, NumPy, and Pandas for analysis and modeling to predict house prices. Utilized Matplotlib and Seaborn for efficient data visualization and insight generation",
    imageUrl: require("../images/california housing.png"),
  },
  {
    title: "Mern base Website for Startup",
    description:
      "Developed a full-fledged website for a startup using the MERN Stack (MongoDB, Express, React, Node.js). Focused on core sections of the website, including services, contact, home, and other major pages. This project showcases my expertise in full-stack web development, with a strong emphasis on front-end design through React and seamless backend integration with Node.js and Express. It also involved ensuring that the site was responsive, scalable, and user-centered, providing an enhanced experience for users and facilitating easy management of services.",
    imageUrl: require("../images/mern website.png"),
  },
  {
    title: "Plant Growth Model",
    description:
      "Designed a plant growth model using Java, with a GUI-based simulation to explore various environmental conditions and resource outputs affecting plant development. The GUI allows users to interactively visualize and manipulate different variables while observing the growth process.",
    imageUrl: require("../images/plant growth model.png"),
  },
  {
    title: "Snake Game",
    description:
      "Developed a classic snake game in Python, utilizing Pygame and Tkinter libraries, along with other Python tools. The game features dynamic gameplay based on user input, with graphical elements handled by the Pygame library and Tkinter used for additional interface components",
    imageUrl: require("../images/snake game.png"),
  },
  // Add more projects here
];

function Projects() {
  return (
    <section id="projects" className="projects-section">
      <h2>Projects</h2>
      <div className="projects-container">
        {projects.map((project, index) => (
          <div
            key={index}
            className="project-card"
            style={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              overflow: "hidden",
              transition: "transform 0.2s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.05)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          >
            <img
              src={project.imageUrl}
              alt={project.title}
              className="project-image"
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
              }}
            />
            <div className="project-details" style={{ padding: "16px" }}>
              <h3 style={{ margin: "0 0 8px" }}>{project.title}</h3>
              <p style={{ margin: "0", color: "#555" }}>
                {project.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Projects;
